import { authStore } from '../stores/auth';

export const parseToken = (token) => {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
};

export const getExpiration = (token) => {
    let output = parseToken(token);
    //Multiply with 1000 to get correct value for JS useage
    return output.exp * 1000;
};

export const startSessionTimer = (token) => {
    let sessionTimer = setInterval(() => {
        if (new Date() > new Date(authStore().expirationTime)) {
            authStore().invalidateSession();
            clearInterval(sessionTimer);
        }
    }, 1000);

    return sessionTimer;
};

/* ---- Validator ---- */
export const mustBe16 = (ssn) => {
    //The user must be older than 16 or turn 16 the same year to register for a account.
    return new Date().getFullYear() - ssn.slice(0, 4) >= 16;
};

export const validatePersonnummer = (ssn) => {
    //let personummer = cleanDigitString(ssn);
    // if (personummer.length > 10) {
    //     personummer = personummer.slice(personummer.length - 10, personummer.length);
    // }

    //return isValidLuhn(personummer) && isPersonnummerDate(personummer);
    return /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])[-+]?\d{4}$/.test(ssn);
};

export const validateOrganisationNumber = (orgnr) => {
    let orgnumber = cleanDigitString(orgnr);

    if (orgnumber.length < 10 || orgnumber.length > 12 || orgnumber.length == 11) {
        //console.log(orgnumber.length);
    }

    return isValidLuhn(orgnumber);
};

/**
 * Remove any non digit characters
 * @param digitString
 * @returns {*}
 */
const cleanDigitString = (digitString) => {
    return digitString.replace(/\D/g, '');
};

/**
 * Check if date is valid for personnummer
 * @param ssn
 * @returns {boolean}
 */
const isPersonnummerDate = (ssn) => {
    let year = parseInt(ssn.substring(0, 2)),
        month = parseInt(ssn.substring(2, 4)),
        day = parseInt(ssn.substring(4, 6)),
        daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Check year and month values
    if (year < 0 || year > 99 || month < 0 || month > 12) {
        return false;
    }

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
        daysInMonth[1] = 29;
    }

    // Check that day is within range
    let dayIsValid = day > 0 && day <= daysInMonth[month - 1];

    // If day is outside range, check if it's +60 for samordningsnummer
    if (!dayIsValid) {
        dayIsValid = day > 60 && day <= daysInMonth[month - 1] + 60;
    }

    return dayIsValid;
};

/**
 * Check if last digit of number is vald Luhn control digit
 * @param ssn
 * @returns {boolean}
 */
const isValidLuhn = (ssn) => {
    let number,
        checksum = 0;
    for (let i = ssn.length - 1; i >= 0; i--) {
        number = parseInt(ssn.charAt(i));
        if (i % 2 == 1) {
            checksum += number;
        } else {
            checksum += number * 2 > 9 ? number * 2 - 9 : number * 2;
        }
    }

    return checksum % 10 == 0;
};
